/*
 * We have two different ways that we are trying to send client
 * side errors to the server. We should unify them or at the very least
 * reconcile why we need both.
 * The other is {@link app/actions/errors/ClientSideErrorActionCreator}.
 *
 * This one sends the client side errors to RTLA JAVASCRIPTERRORSNA
 * directly via HorizonteBrowserDataTargets library.
 * Nothing is sent to HAAWA from here.
 *
 * TODO: https://sim.amazon.com/issues/AUTHOR-11061
 */
const ClientSideMetrics = {
  error: (error, attribution = 'app', message = '', logLevel = 'Error') => {
    if (window.ueLogError) {
      window.ueLogError(error, {
        logLevel,
        attribution,
        message,
      });
    }
  },
  log: (event, value = '', data = {}) => {
    if (window.ue && window.ue.log) {
      window.ue.log(event, value, data);
    }
  },
};

export default ClientSideMetrics;
